let accessToken = null

const tokenStore = {
  get() {
    return accessToken
  },
  set(token) {
    accessToken = token
  },
  clear() {
    accessToken = null
  },
}

export default tokenStore
